import { isDemoUiEnabled } from './demoMode'

export const DemoUiBanner = () => {
  if (!isDemoUiEnabled) {
    return null
  }

  return (
    <div className="market-demo-banner" role="status">
      Демо-режим: показаны тестовые данные для предпросмотра интерфейса
    </div>
  )
}
